exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mp-bucket-selector {\n  align-items: baseline;\n  display: flex;\n  font-size: 14px;\n}\n.mp-bucket-selector mp-select {\n  font-size: 14px;\n}\n.mp-bucket-selector .mp-bucket-selector-label {\n  color: #8f8f91;\n  line-height: 1;\n  padding-right: 8px;\n}\n", ""]);

// exports
